import { LinearGradient } from 'expo-linear-gradient';
import React from 'react';


interface GradientLineProps {
  width: number;
  leftColor: string;
  rightColor: string;
}

export const LinearGradientLine = ({ width, leftColor, rightColor }: GradientLineProps) => {



  return (
    <LinearGradient start={{ x: -1, y: 0 }}
      end={{ x: 1, y: 0 }} colors={[leftColor, rightColor]} style={{width, height:3, borderRadius:50}} />
  );
};

